import axios from "axios";
const qs = require("qs");
export function WhatsappImage(data) {
  return axios({
    method: "POST",

    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },

    data: qs.stringify({
      token: "ttvmvwkhkqaw6hmy",
      to: data.number,
      image: data.image,
      caption: data.caption,
      referenceId: "",
      nocache: "",
    }),

    url: "https://api.ultramsg.com/instance17544/messages/image",
    validateStatus: null,
  });
}
